import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import { useSelector } from "react-redux";
import { AppModal, AppRemixIcon } from "@/layout/AppComponents";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../../routing/helpers/router";
import errorHandler from "@/layout/components/error/ErrorHandler";
import colors from "../../../../../../constants/colors";
import useIsMounted from "../../../../../components/hooks/useIsMounted";

const GenerateReport = (props) => {
  const { moduleBridgeHex, filtersHex } = useParams();
  const { reportType, getModalInfo } = props;
  const global = useSelector((state) => state.global);
  const isMounted = useIsMounted();
  const [reportData, setReportData] = useState();
  const [reportUrl, setReportUrl] = useState();
  const [isError, setIsError] = useState();
  const [calcReport, setCalcReport] = useState();
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState();

  // > GET REPORT
  useEffect(() => {
    if (showModal) {
      const info = {
        percent: 1,
        message: ReactDOMServer.renderToString(
          <Translator
            file="module-intelligence"
            name="preparing.information"
          />,
        ),
      };
      setReportUrl();
      setIsError();
      setModalInfo(info);
      setReportData({
        moduleBridgeHex,
        reportType,
        locale: global.urlData.lang,
        modalInfo: info,
      });
      setCalcReport(0);
    }
  }, [showModal]);

  const handleCalcReport = useCallback(
    async () =>
      axios
        .post(
          axiosPath("api_r_user_module_globalLegalCompliance_report_calculate"),
          { ...reportData, filtersHex },
        )
        .then((r) => {
          if (isMounted.current) setReportData(r.data);
        })
        .catch((e) => {
          setIsError(true);
          errorHandler({
            message: "Error",
            error: {
              name: e.name,
              url: "",
              function: "handleCalcReport",
            },
          });
        }),
    [reportData, filtersHex],
  );

  useEffect(() => {
    if (calcReport) {
      handleCalcReport();
    }
  }, [calcReport]);

  useEffect(() => {
    if (reportData && !reportData.isFinished) {
      setModalInfo(reportData.modalInfo);
      if (getModalInfo) getModalInfo(reportData.modalInfo);
      setCalcReport(calcReport + 1);
    } else if (reportData && reportData.isFinished) {
      setReportUrl(reportData.reportUrl);
    }
  }, [reportData]);
  // < GET REPORT

  // < ICON
  const getIconType = useCallback(() => {
    let type = "file-";
    if (reportType.startsWith("pdf")) {
      type += "pdf";
    } else if (reportType.startsWith("xls")) {
      type += "excel";
    } else if (reportType.startsWith("doc")) {
      type += "word";
    }

    return type;
  }, [reportType]);

  const getIconColor = useCallback(() => {
    let color;
    if (reportType.startsWith("pdf")) {
      color = colors.danger;
    } else if (reportType.startsWith("xls")) {
      color = colors.success;
    } else if (reportType.startsWith("doc")) {
      color = colors.primary;
    }

    return color;
  }, [reportType]);
  // < ICON

  const handleCloseModal = useCallback(() => {
    if (!!(reportUrl || isError)) {
      setShowModal(false);
    }
  }, [reportUrl, isError]);

  return (
    <>
      <div
        key={reportType}
        className="pointer mb-2"
        title={ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="download.report" />,
        )}
        onClick={() => setShowModal(true)}
      >
        <AppRemixIcon
          icon={getIconType(reportType)}
          className="sidebar-icon mr-1"
          color={getIconColor(reportType)}
        />
        <Translator
          file="module-globallegalCompliance"
          name={`module.ggcl.export.${reportType}`}
        />
      </div>
      <AppModal
        size="lg"
        show={showModal}
        onClose={handleCloseModal}
        isCloseButton={!!(reportUrl || isError)}
        title={
          <Translator file="module-legalCompliance" name="export.report" />
        }
      >
        {reportUrl && (
          <div className="text-center">
            <a className="btn btn-sm btn-primary" href={reportUrl}>
              <Translator
                file="module-legalCompliance"
                name="download.report"
              />
            </a>
          </div>
        )}
        {isError && (
          <div className="text-danger">
            <Translator
              file="module-legalCompliance"
              name="error.contact.admin"
            />
          </div>
        )}
        {!reportUrl && !isError && (
          <>
            <h2>{modalInfo?.message}</h2>
            <ProgressBar
              animated
              now={modalInfo?.percent}
              label={`${parseInt(modalInfo?.percent)}%`}
            />
          </>
        )}
      </AppModal>
    </>
  );
};

export default GenerateReport;
